import _, { isEqual } from 'lodash'
import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate, useLocation } from 'react-router-dom'

// const Wrapper = React.lazy(() => import('components/wrapper/Wrapper'))

export const AuthRoute = ({ component: Component }) => {
	const location = useLocation()
	const auth = useSelector(state => state.currentUser, isEqual)
	return !auth.isUserLoggedIn || true ? (
		<>
			<React.Suspense>
				<Component />
			</React.Suspense>
		</>
	) : (
		<Navigate
			to={{ pathname: '/home/dashboard' }}
			replace
			state={{ from: location }}
		/>
	)
}

export const OpenRoute = ({ component: Component }) => {
	return (
		<>
			<React.Suspense>
				<Component />
			</React.Suspense>
		</>
	)
}

export const DashboardRoute = ({ component: Component }) => {
	const auth = useSelector(state => state.currentUser, isEqual)
	return !_.isEmpty(auth.loggedInUserData) ? (
		// <Wrapper>
			<>{Component}</>
		// </Wrapper>
	) : (
		<Navigate replace to={{ pathname: '/login' }} />
	)
}
